module.exports = __webpack_public_path__ + "static/media/bg4.63aa86a7.jpg";